import React, { useContext, useReducer, useState } from "react";

import CardSuccessPayment from "../components/CardSuccessPayment";
import CardErrorPayment from "../components/CardErrorPayment";

import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";
import useMerchantStorage from "../hooks/useMerchantPago";
import {
  crearGenerarLinkPago,
  obtenerRegistroPagoXMerchant,
  obtenerVerificacionPago,
} from "../services/transaccionalService";
import TransaccionalContext from "../context/TransaccionalContext";

import { Card, CardContent, Divider, Typography } from "@mui/material";
import CardWarningLinkPago from "../components/CardWarningLinkPago";
import {
  initialModalState,
  modalNotificacionReducer,
} from "app/modules/common/components/Modals/ModalHandleNotificaciones/modalNotificacionReducer";
import { useSelector } from "react-redux";
import ModalHandleNotification from "app/modules/common/components/Modals/ModalHandleNotificaciones/ModalHandleNotification";

const FlujoValidarPagoPLux = ({ alturaResolucion }) => {
  const { authUser } = useSelector(({ auth }) => auth);

  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  const [loadingPayment, setLoadingPayment] = useState(false);

  const [modalState, modalDispatch] = useReducer(
    modalNotificacionReducer,
    initialModalState
  );

  const [idMerchantStorage, setIdMerchantStorage] = useMerchantStorage(
    "idMerchantStorage",
    null
  );

  const [statePayment, setStatePayment] = useState("");

  const verificarPago = async () => {
    try {
      const respuestaValidateMerchat = await obtenerRegistroPagoXMerchant(
        informacionTransaccional?.merchantId
      );

      console.log(respuestaValidateMerchat);

      setStatePayment(respuestaValidateMerchat);

      setInformacionTransaccional((args) => ({
        ...args,
        verificarPayment: false,
        /* updateValidacionPago: !args.updateValidacionPago, */
      }));
    } catch (error) {
      console.log(error);

      setStatePayment({
        mensaje: {
          codigo: "99",
          mensaje: "ERROR VALIDADNDO EL PAGO",
        },
        customer: {},
      });

      setInformacionTransaccional((args) => ({
        ...args,
        verificarPayment: false,
        /* updateValidacionPago: !args.updateValidacionPago, */
      }));
    }
  };

  const handleUpdatePayment = () => {
    console.log("update payment header");
    setInformacionTransaccional((args) => ({
      ...args,
      updateValidacionPago: !args.updateValidacionPago,
      opcionMenu: 0,
      stateVerificar: false,
    }));
  };

  const obtenerLinkPago = async () => {
    //SETEAR VARIABLES link payment
    setInformacionTransaccional((args) => ({
      ...args,
      stateVerificar: false, //cambiar de component deobtener URL a  verifiquar
      verificarPayment: true,
      updateValidacionPago: false,
    }));
  };

  return (
    <div>
      {informacionTransaccional?.verificarPayment ? (
        <main className="cardInformacionLinkPago_card">
          <Card
            variant="outlined"
            sx={{
              height: "40vh",
              width: "25vw",
              "@media (max-width: 1024px)": {
                width: "40vw", // Para tablets
                /*  height: "50vh", */
              },
              "@media (max-width: 768px)": {
                width: "60vw", // Para celulares grandes
                /*  height: "60vh", */
              },
              "@media (max-width: 425px)": {
                width: "80vw", // Para celulares pequeños
                /*   height: "70vh", */
              },
            }}
          >
            <CardContent
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                gutterBottom
                sx={{
                  color: "text.primary",
                  fontSize: 25,
                  margin: "0.75rem",
                  fontWeight: "600",
                  "@media (max-width: 1360px)": {
                    margin: "0.25rem",
                    fontSize: 20,
                  },
                }}
              >
                Verificación Pago
              </Typography>
              <Divider sx={{ width: "100%" }} />

              <Typography
                variant="h4"
                component="div"
                sx={{
                  fontSize: 18,
                  margin: "0.5rem",
                  "@media (max-width: 1360px)": {
                    fontSize: 14,
                  },
                }}
              >
                {`Verifiqua aquí el estado de tu pago !`}
              </Typography>
              <Divider sx={{ width: "100%" }} />

              <SCSGenericButton
                size={70}
                titulo="Verificar pago"
                onClick={verificarPago}
              />
            </CardContent>
          </Card>
        </main>
      ) : (
        <section style={{ width: "100%", margin: "0 auto" }}>
          {/* TODO verificar todos los posible codigos de la respuesta */}
          {statePayment?.procesado &&
          statePayment?.verificaPago &&
          statePayment?.pagoExitoso ? (
            <CardSuccessPayment handleUpdatePayment={handleUpdatePayment} />
          ) : statePayment?.procesado &&
            statePayment?.verificaPago &&
            !statePayment?.pagoExitoso ? (
            <>
              <CardWarningLinkPago
                mensajeWarning={"Pago No Procesado"}
                handleRender={obtenerLinkPago}
                mensajeBoton="Generar Link"
                detalleMensaje={
                  "El proceso de pago no pudo completarse, intentelo nuevamente."
                }
              />
            </>
          ) : statePayment?.procesado &&
            !statePayment?.verificaPago &&
            !statePayment?.pagoExitoso ? (
            <>
              <CardWarningLinkPago
                mensajeWarning={"Proceso De Pago No Completado"}
                detalleMensaje={
                  "El proceso de pago no fue completado, continue con el pago."
                }
                handleRender={obtenerLinkPago}
                mensajeBoton="Completar pago"
              />
            </>
          ) : !statePayment?.procesado &&
            !statePayment?.verificaPago &&
            !statePayment?.pagoExitoso ? (
            <>
              <CardWarningLinkPago
                mensajeWarning={"Proceso De Pago No Completado"}
                detalleMensaje={
                  "El proceso de pago no fue completado, continue con el pago."
                }
                handleRender={obtenerLinkPago}
                mensajeBoton="Completar pago"
              />
            </>
          ) : (
            <CardErrorPayment
              mensajeWarning={statePayment?.mensaje}
              handleRender={verificarPago}
            />
          )}
        </section>
      )}

      <ModalHandleNotification
        parameters={modalState}
        setOpen={() => modalDispatch({ type: "CLOSE_MODAL" })}
      />
    </div>
  );
};

export default FlujoValidarPagoPLux;
